import { produce } from 'immer'
import React from 'react'

import { PlannerName } from '../enums/PlannerNameEnum'
import { IContext } from '../types/IContext'
import { Actions } from './reducer'

export const initialContext: IContext = {
  user: {
    fullname: '',
    email: '',
  },
  bannerMessages: [],
  ingredients: [],
  planner: PlannerName.None,
  unsavedChanges: false,
}

export const Context = React.createContext<{
  state: IContext
  dispatch: React.Dispatch<Actions>
}>({
  dispatch: () => undefined,
  state: initialContext,
})

export const useImmerReducer = (reducer: any, initialState: IContext) =>
  React.useReducer(produce(reducer), initialState)
